import { render, staticRenderFns } from "./Leftnav.vue?vue&type=template&id=57254377&"
import script from "./Leftnav.vue?vue&type=script&lang=js&"
export * from "./Leftnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports